import { has } from "../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                    result = true || result;
                }
            }
            return result;
        },
        canApprove: ({ record }) => {
            let result = false;
            if (["waitApproveCenter"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return (
                    [
                        "refUserTemp.refPersonType",
                        "refUserTemp.refCompanyType",
                        "refUserTemp.companyNameTh",
                        "refUserTemp.companyNameEn",
                        "refUserTemp.registerDate",
                        "refUserTemp.refDepartmentRegister",
                        "refUserTemp.refDepartmentRegister.nameEn"
                    ].includes(field?.key) || new RegExp(`^refUserTemp\\.addresses.*$`, "g").test(field?.key)
                );
            },
            visibleField: () => false
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.refDepartment.nameEn", "refUserTemp.refJobPosition.nameEn"].includes(field?.key);
            },
            inputPropField: () => ({ disabled: true })
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.buttonCheckIdCard"].includes(field?.key);
            },
            visibleField: ({ initialModel }) => {
                let result = false;
                if (["waitApproveCenter"].includes(initialModel.refStatus?.key)) {
                    result = true || result;
                }
                return result;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forOfficeRemark.0.remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            },
            visibleField: ({ initialModel }) => {
                let result = false;
                if (["1"].includes(initialModel.refRequestType?.key)) {
                    result = true || result;
                }
                return result;
            }
        },
        {
            check: ({ field }) => {
                return ["refUserTemp.refOfficerLv"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return { disabled: !enabled };
            },
        },
        {
            check: ({ componentKey }) => ["AttachmentInlineList"].includes(componentKey),
            inputPropField: () => ({ canCreate: false, canDelete: false })
        },
        {
            check: () => {
                return true;
            },
            inputPropField: () => ({ disabled: true })
        }
    ];
};
